<template>
    <div>
        <div class="w-full text-center viva-drop-submit-button">
            <button type="submit" class="border-0 w-full rounded-lg font-bold h-16 text-xl font-roundo-bold text-viva-money-black outline-none bg-viva-money-secondary-yellow focus:outline-none" 
            :class="[ this.$attrs['class']]">
                <slot></slot>
            </button>
        </div>
    </div>
</template>

<script>
import { isString } from "underscore";
export default {
    props: {
        'form': {},
    },
    computed: {
    }
};
</script>

<style lang="scss" scoped>
</style>